<div class="c-wrapper">
    <div class="c-n-wrapper">
        <span multilang class="ratting">
            <mat-icon class="rico" *ngFor="let cat of categoryAr;">{{cat === 1 ? 'star':
                'star_half'}}</mat-icon>
        </span>
        <div class="topw">
            <span multilang class="c-title">{{hotel?.name}}</span>
            <ng-container *ngIf="hotel?.rating?.recommendation > 0">
                <div class="purswr">
                    <mat-icon class="pursico">thumb_up_alt</mat-icon>
                    <span multilang class="purct">{{hotel?.rating?.recommendation}}%</span>
                </div>
            </ng-container>
        </div>

        <div class="dg-info-item mt">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Reisezeitraum:</span>
            <span multilang>{{booking?.commonOffer?.travelDate?.fromDate | date:'dd.MM.yyyy'}} -
                {{booking?.commonOffer?.travelDate?.toDate | date:'dd.MM.yyyy'}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Dauer:</span>
            <span multilang>{{booking?.commonOffer?.travelDate?.duration}}
                {{booking?.commonOffer?.travelDate?.duration
                === '1' ?
                'Nacht' : 'Nächte'}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Zimmer:</span>
            <span multilang>{{booking?.commonOffer?.hotelOffer?.roomType?.name}}
                {{booking?.commonOffer?.hotelOffer?.locatedList?.join(',')}}
                {{booking?.commonOffer?.hotelOffer?.facilityList?.join(',')}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Verpflegung:</span>
            <span multilang>{{booking?.commonOffer?.hotelOffer?.boardType?.name}}</span>
        </div>

        <ng-container *ngIf="transferMessage?.length > 0">
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Transfer:</span>
                <span multilang>inkl. Transfer</span>
            </div>
        </ng-container>
        <ng-container *ngIf="zugMessage?.length > 0;">
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Zug:</span>
                <span multilang>{{zugMessage}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="mwMessage?.length > 0;">
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Mietwagen:</span>
                <span multilang>{{mwMessage}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="spMessage?.length > 0;">
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Skipass:</span>
                <span multilang>{{spMessage}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="wlMessage?.length > 0;">
            <div class="dg-info-item">
                <span multilang [class.dg-info-item-first]="deskMode"
                    [class.dg-info-item-first-mobile]="!deskMode">Wellness:</span>
                <span multilang>{{wlMessage}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="hotel?.keywordList?.length > 0">
            <keywords [data]="hotel?.keywordList" class="keywordList"></keywords>
        </ng-container>
        <div class="offerinfodet">
            <app-offerpackspecinfo [mode]="'pauschal'" [offer]="booking?.commonOffer" [hotel]="hotel">
            </app-offerpackspecinfo>
        </div>
    </div>

    <div class="c-block">
        <div class="c-item">
            <span multilang class="c-item-title">Preis</span>
            <div class="offerprice">
                <span multilang class="f400">{{travelerText}}</span>
                <span multilang multilang deeplMode='html' [innerHtml]="prcdetail | safehtml"></span>
                <div class="offerpriceTotal">
                    <span multilang>Gesamtpreis:</span>
                    <span multilang class="prccolor ml">{{booking?.totalPrice?.value | number:'1.2-2'}}
                        {{booking?.totalPrice?.currency}}</span>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="booking?.extracomment?.length > 0">
        <div class="c-block">
            <div class="c-item">
                <span multilang class="c-item-title">Extra info</span>
                <div class="v-wrapper">
                    <pre class="ml pree">{{booking?.extracomment}}</pre>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="c-block">
        <ng-container *ngIf="booking?.commonOffer?.tourOperator?.name?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Veranstalter</span>
                <div class="v-wrapper">
                    <img *ngIf="booking?.commonOffer?.tourOperator?.png?.length > 0"
                        src="{{booking?.commonOffer?.tourOperator?.png}}" class="lazyload" height="24px"
                        alt="{{booking?.commonOffer?.tourOperator?.name}}">
                    <span multilang class="ml">{{booking?.commonOffer?.tourOperator?.name}}
                        ({{booking?.commonOffer?.tourOperator?.code}})</span>
                    <span multilang class="ml ul"><a multilang [href]="booking?.commonOffer?.tourOperator?.agb"
                            target="blank">AGB</a></span>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="booking?.commonOffer?.flightOffer?.flight?.inbound?.legList?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">{{booking?.mode === 'railtravel'? 'Fahrtdetail' :
                    'Flugdetail'}}</span>
                <ng-container *ngIf="deskMode else infomobilemode">
                    <ng-container
                        *ngTemplateOutlet="finfo; context:{flugs: booking.commonOffer.flightOffer.flight.outbound.legList}">
                    </ng-container>
                    <div class="mt">
                        <ng-container
                            *ngTemplateOutlet="finfo context:{flugs: booking.commonOffer.flightOffer.flight.inbound.legList}">
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="hotel?.catalogData?.imageList?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Bilder</span>
                <div class="imgw">
                    <ng-container *ngFor="let im of hotel?.catalogData?.imageList;let k=index">
                        <img *ngIf="im?.length > 0" (click)="openImageModal(k)" src="{{im | cacheResource}}"
                            class="lazyload myimg">
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="hotel?.catalogData?.html?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Hotelinformationen</span>
                <div multilang deeplMode='html' [innerHtml]="hotel.catalogData.html | safehtml" class="vorteile">
                </div>
            </div>
        </ng-container>
    </div>

    <div class="c-block">
        <ng-container *ngIf="hotel?.location?.latitude?.length > 0">
            <div class="c-item">
                <span multilang class="c-item-title">Lage</span>
                <ng-container *ngTemplateOutlet="lage"></ng-container>
            </div>
        </ng-container>
    </div>

    <div class="f-btn-wrapper">
        <button class="f-btn colorB" matRipple (click)="sendBooking()">Jetzt buchen</button>
        <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
    </div>
</div>

<ng-template #finfo let-flugs="flugs">
    <ng-container *ngIf="flugs?.length > 0">
        <div class="f-info-wrapper">
            <div class="f-info-a">
                <span multilang>{{flugs[0].departureAirportName}}</span>
                <mat-icon class="f-info-a-icon" [class.rottate]="booking?.mode !== 'railtravel'">{{booking?.mode ===
                    'railtravel' ? 'train' : 'flight'}}</mat-icon>
                <span multilang>{{flugs[flugs.length - 1].arrivalAirportName}}</span>
                <span multilang class="f-stopps"><span multilang class="it">Stopps:</span> {{flugs.length -
                    1}}</span>
            </div>
            <ng-container *ngFor="let fl of flugs">
                <div class="f-info-date">
                    <span multilang>{{fl.departureDate | date:'EEE, dd.MM.yyyy'}}</span>
                    <span multilang>{{fl.flightCarrierName}} ({{fl.flightNumber}})</span>
                    <span multilang class="w-20">{{fl.departureAirportName}} ({{fl.departureAirportCode}})</span>
                    <span multilang class="w-20">{{fl.arrivalAirportName}} ({{fl.arrivalAirportCode}})</span>
                    <div class="t-wrapper">
                        <span multilang class="ml">{{fl.departureTime}}</span>
                        <div class="ml a-time">
                            <span multilang>{{fl.arrivalTime}}</span>
                        </div>
                        <div class="ml a-time">
                            <span multilang><span multilang class="it">Dauer:</span>
                                {{fl.estimatedElapsedTime}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #infomobilemode>
    <ng-container
        *ngTemplateOutlet="finfoMobile; context:{flugs: booking.commonOffer.flightOffer.flight.outbound.legList}">
    </ng-container>
    <div class="mt">
        <ng-container
            *ngTemplateOutlet="finfoMobile context:{flugs: booking.commonOffer.flightOffer.flight.inbound.legList}">
        </ng-container>
    </div>
</ng-template>


<ng-template #finfoMobile let-flugs="flugs">
    <ng-container *ngIf="flugs?.length > 0">
        <div class="f-info-wrapper">
            <div class="f-info-a">
                <span multilang>{{flugs[0].departureAirportName}}</span>
                <mat-icon class="f-info-a-icon">flight</mat-icon>
                <span multilang>{{flugs[flugs.length - 1].arrivalAirportName}}</span>
                <!--span class="f-stopps"><span  multilang   class="it">Stopps:</span> {{flugs.length - 1}}</span-->
            </div>
            <ng-container *ngFor="let fl of flugs;let k=index">
                <div class="f-info-date-mobile">
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Von</span>
                        <span multilang>{{fl.departureAirportName}} ({{fl.departureAirportCode}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Nach</span>
                        <span multilang>{{fl.arrivalAirportName}} ({{fl.arrivalAirportCode}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Datum</span>
                        <span multilang>{{fl.departureDate | date:'EEEE, dd.MM.yyyy'}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Flug</span>
                        <span multilang>{{fl.flightCarrierName}} ({{fl.flightNumber}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Abflug</span>
                        <span multilang>{{fl.departureTime}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Ankunft</span>
                        <span multilang>{{fl.arrivalTime}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Dauer</span>
                        <span multilang>{{fl.estimatedElapsedTime}}</span>
                    </div>
                </div>
                <ng-container *ngIf="k < flugs.length -1">
                    <mat-divider class="mb mt"></mat-divider>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<div class="fixedlefttop">
    <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
    <button class="f-b-top" matRipple (click)="sendBooking()">Jetzt buchen</button>
</div>

<ng-template #lage>
    <div class="mymap">
        <div id="map" class="mapw"></div>
    </div>
</ng-template>